var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotIncluded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "not included") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#EBD1D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.4734 22 22.0087 17.4734 22.0087 12C22.0087 6.52659 17.4647 2 11.9913 2C6.52267 2 2 6.52659 2 12C2 17.4734 6.53138 22 12 22ZM12 20.5272C7.28039 20.5272 3.48627 16.7283 3.48627 12C3.48627 7.27167 7.27168 3.47276 11.9913 3.47276C16.7196 3.47276 20.5272 7.27167 20.5272 12C20.5272 16.7283 16.7283 20.5272 12 20.5272ZM8.58106 16.1283C8.78661 16.1283 8.95906 16.0595 9.09097 15.9141L11.9913 13.0011L14.9003 15.9141C15.041 16.0547 15.2086 16.1283 15.415 16.1283C15.8056 16.1283 16.1196 15.8182 16.1196 15.4267C16.1196 15.2251 16.0421 15.0662 15.9093 14.9208L12.9972 12.0126L15.918 9.08705C16.0595 8.94162 16.1283 8.78269 16.1283 8.59369C16.1283 8.1983 15.8143 7.89696 15.4237 7.89696C15.2347 7.89696 15.0845 7.95705 14.9264 8.11119L11.9913 11.0289L9.08226 8.11991C8.94163 7.97054 8.78661 7.90567 8.58106 7.90567C8.19438 7.90567 7.88043 8.20701 7.88043 8.59848C7.88043 8.79138 7.95401 8.95905 8.09076 9.09577L10.9989 12.0126L8.09076 14.9295C7.95401 15.0662 7.88043 15.2338 7.88043 15.4267C7.88043 15.8182 8.19438 16.1283 8.58106 16.1283Z",
    fill: "#9E1E19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotIncluded);
export default __webpack_public_path__ + "static/media/notIncluded.7f099d501c9c372d81eba6b013ff08fc.svg";
export { ForwardRef as ReactComponent };